"use client";
import React, { useState } from "react";
import MoneyExchange from "./MoneyExchange.mobile";
import styles from "./JobHeader.mobile.module.scss";

const JobHeader = ({ transData, data }) => {
  const [rate, setRate] = useState("");
  return (
    <div className={styles.jobHeader}>
      {data.is_pending_job ? <span className={styles.pending}>{data.pending_job_text}</span> : null}
      <h3>{transData.isOriginal ? data.job_title : data.translationTitle}</h3>
      <p className={styles.companyName}>{data?.company_name}</p>
      <div className={styles.salaryInfo}>
        {rate || data.salary_info.text}
        {data.salary_info.type_text ? (
          <span className={styles.type}>[{data.salary_info.type_text}]</span>
        ) : null}
        <MoneyExchange
          data={data?.salary_info}
          onCloseHandler={(value) => {
            setRate(value);
          }}
        />
      </div>
      <div className={styles.tags}>
        {data.is_urgent ? (
          <span className={styles.urgent}>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='14'
              height='15'
              viewBox='0 0 14 15'
              fill='none'
            >
              <path
                d='M9.99063 2.20557H5.78242C5.5868 2.20557 5.40953 2.32077 5.33008 2.49953L2.72389 8.36346C2.5784 8.6908 2.81801 9.05951 3.17623 9.05951H5.8415L4.53885 13.6188C4.48204 13.8176 4.72968 13.9595 4.87246 13.8099L11.5159 6.85011C11.8166 6.5351 11.5933 6.01331 11.1578 6.01331H8.8877L10.4334 2.92195C10.5979 2.59282 10.3586 2.20557 9.99063 2.20557Z'
                fill='black'
              />
            </svg>
            {data.urgent_text}
          </span>
        ) : null}
        {data.location ? <span>{data.location}</span> : null}
        {data.location ? (
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='3'
            height='4'
            viewBox='0 0 3 4'
            fill='none'
          >
            <circle cx='1.25' cy='2' r='1.25' fill='#515151' />
          </svg>
        ) : null}
        {data.job_type ? <span>{data.job_type}</span> : null}
        {data.job_type ? (
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='3'
            height='4'
            viewBox='0 0 3 4'
            fill='none'
          >
            <circle cx='1.25' cy='2' r='1.25' fill='#515151' />
          </svg>
        ) : null}
        {data.xp_lvl ? <span>{data.xp_lvl}</span> : null}
        {data.xp_lvl ? (
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='3'
            height='4'
            viewBox='0 0 3 4'
            fill='none'
          >
            <circle cx='1.25' cy='2' r='1.25' fill='#515151' />
          </svg>
        ) : null}
        {data.degree ? <span>{data.degree}</span> : null}
      </div>
    </div>
  );

  return null;
};

export default JobHeader;
